import action from '../helpers/rest-client';
import { GetInAppNotificationsOutDto } from '../types/in-app-notification.dto';

class InAppNotification {
  public async getNotifications({ page = 1, perPage = 15 }: GetInAppNotificationsOutDto) {
    return action
      .Get({
        url: `/api/in-app-notifications?page=${page}&perPage=${perPage}`,
      })
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  public async getUnreadCount() {
    return action
      .Get({
        url: `/api/in-app-notifications/unread-count`,
      })
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  public async markAsRead({ id }: { id: number }) {
    return action
      .Put({
        url: `/api/in-app-notifications/${id}/read`,
      })
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  public async markAllAsRead() {
    return action
      .Put({
        url: `/api/in-app-notifications/read-all`,
      })
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }
}

const inAppNotification = new InAppNotification();
export default inAppNotification;
